import React from 'react';
import TopOne from './TopOne';
import NavTwo from './NavTwo';

const HeaderThree = () => {
    return(
        <>
        <header className="o-header">
            <TopOne />
            
            <NavTwo />
        </header>
        </>
    )
}

export default HeaderThree;